import {createSelector} from 'reselect';

const tour = (state) => state.notebook.tour;
export const getTour = createSelector([tour], (tour) => tour);

const stepIndex = (state) => state.notebook.stepIndex;
export const getStepIndex = createSelector(
  [stepIndex],
  (stepIndex) => stepIndex
);

const tourData = (state) => state.notebook.notebook.tourData;
export const getTourData = createSelector([tourData], (tourData) => tourData);
